import React, { useEffect, useState } from "react";
import io from "socket.io-client";
import './moreNews.css'
import MoreNewsCart from "./MoreNewsCart";

const socket = io.connect("https://mayapurapp.ap-1.evennode.com");

const MoreNews = () => {
  const [moreNews, setMoreNews] = useState([]);
  const [startIndex, setStartIndex] = useState(16);
  const [moreButtonYear, setMoreButtonYear] = useState(2025);

  useEffect(() => {
    const handleMoreNews = (dataObject) => {
      const more16Headlines = [...dataObject].sort(
        (a, b) => parseFloat(a.block_number) - parseFloat(b.block_number)
      );

      let getLowestDate = 999999999999999;
      for (let i = more16Headlines.length - 1; i >= 0; i--) {
        if (more16Headlines[i]["block_number"] < 17) {
          more16Headlines.splice(i, 1);
        } else if (more16Headlines[i]["_id"] < getLowestDate) {
          getLowestDate = more16Headlines[i]["_id"];
          const date = new Date(parseInt(getLowestDate));
          setMoreButtonYear(date.getFullYear());
        }
      }

      const newStartIndex = more16Headlines.length;
      setMoreNews((prevNews) => [...prevNews, ...more16Headlines]);

      if (newStartIndex < 16) {
        socket.emit(
          "get16MoreNewsHeadlines",
          startIndex + newStartIndex,
          moreButtonYear
        );
        setStartIndex((prev) => prev + newStartIndex);
      } else {
        setStartIndex((prev) => prev + 16);
      }
    };

    socket.on("16MoreNewsHeadlinesRetrieved", handleMoreNews);
    return () => socket.off("16MoreNewsHeadlinesRetrieved", handleMoreNews);
  }, [startIndex, moreButtonYear]);

  const moreButton = () => {
    socket.emit("get16MoreNewsHeadlines", startIndex, moreButtonYear);
  };

  return (
    <div className="mb-8 mx-3">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-4">
        {moreNews.map((items) => (
          <MoreNewsCart key={items._id} item={items} />
        ))}
      </div>

      <div className="text-center my-5 mx-auto">
        {/* <button
          className="btn bg-blue-500 hover:bg-blue-800 text-white px-14"
          onClick={moreButton}
        >
          আরো খবর..
        </button> */}
        <div className="flex items-center justify-center">
          <button onClick={moreButton} type="button" className="btn-b text-white">
            <strong>আরো খবর..</strong>
            <div id="container-stars">
              <div id="stars"></div>
            </div>
            <div id="glow">
              <div className="circle"></div>
              <div className="circle"></div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoreNews;
